import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("user_access.title"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v(" " + _vm._s(_vm.$t("user_access.subtitle")) + " "),
          ]),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onDownload },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("download")]),
                  _vm._v(" " + _vm._s("Descargar") + " "),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.$t("frases.filter")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.Items,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    "item-class": "table-inca-no_data",
                    responsive: "",
                    "items-per-page": _vm.pagination.limit,
                    page: _vm.pagination.current,
                    loading: _vm.isLoading,
                    disabled: _vm.isLoading,
                    search: _vm.search,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header.last_date",
                      fn: function (ref) {
                        var header = ref.header
                        return [
                          _vm._v(" " + _vm._s(header.text) + "´ "),
                          _c(
                            VTooltip,
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var attrs = ref.attrs
                                      var on = ref.on
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              { attrs: { icon: "" } },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v(
                                                " mdi-help-circle-outline "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Fecha de inicio de sesión")])]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.creation_date",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(VIcon, [_vm._v(" mdi-calendar ")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getDateAndHours(item.creation_date).date
                              ) +
                              " "
                          ),
                          _c(VIcon, [_vm._v(" mdi-clock-outline ")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getDateAndHours(item.creation_date).hour
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.last_date",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(VIcon, [_vm._v(" mdi-calendar ")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.getDateAndHours(item.last_date).date) +
                              " "
                          ),
                          _c(VIcon, [_vm._v(" mdi-clock-outline ")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.getDateAndHours(item.last_date).hour) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDeleteUser(
                                                      item.email
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-delete"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Eliminar usuario")])]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VCard,
                      { staticClass: "filters-inca" },
                      [
                        _c(
                          VCardTitle,
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                _vm.collapse_filter = !_vm.collapse_filter
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("titles.search_filters")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          VCardText,
                          { staticClass: "pa-2 pt-0" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "dense" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VTextField, {
                                      attrs: {
                                        label: _vm.$t("user_access.email"),
                                        placeholder:
                                          _vm.$t("user_access.email"),
                                        type: "text",
                                        outlined: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.filter.text_filter,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "text_filter",
                                            $$v
                                          )
                                        },
                                        expression: "filter.text_filter",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        label: _vm.$t("user_access.domain"),
                                        name: "domain",
                                        placeholder:
                                          _vm.$t("user_access.domain"),
                                        items: _vm.domains,
                                        "item-value": "id",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.filter.domain,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filter, "domain", $$v)
                                        },
                                        expression: "filter.domain",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 text-right" },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: { outlined: "outlined" },
                                        on: { click: _vm.onLimpiar },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                    ),
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "primary ",
                                        on: { click: _vm.onSearch },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }